export default __webpack_public_path__ + "static/media/calendar-BG.de2269ee.png";